import styled from 'styled-components';
import Colors from '@/constants/Colors';

export const StyledActivity = styled.div`
  -—appheight: 100%;
  --fullScreenBackground: black;
  width: 100%;
  height: 100%;

  &.with-warning {
    height: calc(100% - 60px);
  }

  .activity-wrapper {
    width: 100%;
    height: 100%;
    &.fullscreen {
      position: fixed;
      width: 100%;
      height: var(--appheight) !important;
      top: 0;
      left: 0;
      background: var(--fullScreenBackground);
      z-index: 999999;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .activity-canvas {
      width: 100%;
      height: 100%;
    }
  }
  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  .sign-up {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${Colors.backgroundPaleBlue};
    border-radius: 8px;
    .not-available {
      padding: 2em 2em 1em;
      .buttons {
        display: flex;
        justify-content: center;
        gap: 0.75em;
      }
    }
  }

  .description {
    margin-top: 20px;

    img {
      max-width: 100%;
      height: auto;
    }
  }

  @media (orientation: landscape) {
    .activity-wrapper.fullscreen {
      gap: 10px;

      .activity-canvas {
        flex: 1;
        max-height: var(--appheight) !important;
      }
    }
  }
`;

export const StyledDemoWarning = styled.div`
  height: 50px;
  margin-bottom: 10px;
`;
